export default __webpack_public_path__ + "../ckeditor/plugins/icons_hidpi.png";